import * as React from 'react';
import { IDs } from '../../../../helpers/IDs';
import { WFormsTableWrapper } from '../../../../core/table/WFormsTableWrapper';
import { WHelpIcon } from '../../../../core/elements/WHelpIcon';

export interface MehrsprachigkeitOnlineHilfeProps {
    data: any;
}

export interface MehrsprachigkeitOnlineHilfeState {

}

export class MehrsprachigkeitOnlineHilfe extends React.Component<MehrsprachigkeitOnlineHilfeProps, MehrsprachigkeitOnlineHilfeState> {

    constructor(props: any) {
        super(props);
        this.state = {

        };
    }

    render(): JSX.Element {
        const config: any = require('../../../../wips.config.js');
        const devFeaturesMap: any = config.devFeaturesMap || {};
        const customFormatter = (key: string, value: any, dataIn: any, row: any) => {
            if (key === 'description') {
                return <WHelpIcon
                    label='Bearbeiten'
                    helpKey={dataIn.modul}
                    type={'edit'}
                    data={this.props.data}
                    editBar={true}
                    directEdit={true}
                    isMultilingual={!!devFeaturesMap.N207_MEHRSPRACHIGKEIT}
                />;
            }
            if (key === 'description_ext_1_bereich' || key === 'description_ext_2_bereich' || key === 'description_ext_3_bereich') {
                if (!value || value === '0') {
                    return '';
                }
            }
            return value;
        };
        return (
            <div>
                <WFormsTableWrapper
                    entity={IDs.ENT_ONLINE_HILFE}
                    module={IDs.MOD_ETOOL_ADMIN}
                    actions={[]}
                    customClass={'Custom-ETA'}
                    formLayout={'flowV2'}
                    hiddenColumns={['stamp', 'description2', 'description_ext_1', 'description_ext_2', 'description_ext_3',
                        'description_ext_1_bereich', 'description_ext_2_bereich', 'description_ext_3_bereich', 'auto_open']}
                    showColumnsHelp={false}
                    customFormatter={customFormatter}
                    columnWidths={[null, null, 80]}
                    tablePageSize={10}
                    defaultSorted={[{ id: 'name', asc: true }]}
                    hideExport
                />
            </div>
        );
    }
}
